module.exports = __webpack_public_path__ + "static/img/03_lea_cornelius_carstens.d4dd8d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/lea/03_lea_cornelius_carstens.jpg
// module id = D8EV
// module chunks = 1